/**
 * 列表信封解包。
 *
 * ============================================================================
 * 为什么需要这个函数（这是本项目踩过的真实缺陷）
 * ============================================================================
 *
 * 后台**所有**列表接口返回的都是信封对象：
 *
 *   {"code":0,"data":{"list":[...],"total":N,"page":1,"pageSize":20,"hasMore":false}}
 *
 * 而前端有若干处把 `data` 直接当数组用（`for (const c of categories.value)`、
 * `el-tree :data`、`el-table :data`）。结果是：
 *   - `el-tree/el-table` 拿到对象 → 一个节点都渲染不出来；
 *   - `for...of` 遍历对象 → 抛 `xxx is not iterable` → **整个页面渲染中断**（一片空白）。
 *
 * 真实的两个用户可见症状都源于此：
 *   「后台分类管理添加分类后不显示」
 *   「新建商品也没有显示」（商品列表页同时要用分类做筛选，遍历分类时抛错把整页带崩，
 *     连取商品的请求都没发出去 —— 已由 nginx 日志证实）
 *
 * 之所以长期没被发现：mock 路由返回的是**裸数组**，与"当数组用"的错误假设一致，
 * 单测全绿、对着 mock 开发也一切正常。
 *
 * 因此这里统一解包，并且**两种形状都兼容**（真实信封 + 裸数组），
 * 调用方（api 层）负责用它把 `data` 归一成数组再交给页面。
 */
export function unwrapList<T>(data: unknown): T[] {
  if (Array.isArray(data)) return data as T[];
  if (data !== null && typeof data === 'object') {
    const list = (data as { list?: unknown }).list;
    if (Array.isArray(list)) return list as T[];
  }
  // 形状不符合预期时返回空数组，而不是 undefined ——
  // 页面拿到 undefined 后一句 for...of / .map 就会把整页带崩。
  return [];
}
